module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-6.921ee7cb.png";